import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentEvent } from '../../redux/calendar';
import dateUtil from '../../util/dateUtil';
import EventCard from './EventCard';

const DetectMeeting = () => {
  const dispatch = useDispatch();
  const event = useSelector((state) => state.calendar.current);
  const timecard = useSelector((state) => state.timecard);

  useEffect(() => {
    dispatch(getCurrentEvent());
  }, []);
  useEffect(() => {
    const timer = setInterval(() => dispatch(getCurrentEvent()), 60000);
    return () => clearInterval(timer);
  });

  const [show, setShow] = useState(false);
  useEffect(() => {
    if (event?.start?.dateTime) {
      const matchingEntry = timecard.entries.some((entry) => {
        const entryDate = dateUtil.toDateTimeString(
          new Date(
            entry.startDate.split('T')[0] +
              'T' +
              entry.startTime.split('T')[1].slice(0, -1)
          )
        );
        const eventDate = dateUtil.toDateTimeString(new Date(event?.start?.dateTime + 'Z'));
        if (entryDate == eventDate) {
          return true;
        }
      });
      if (matchingEntry) setShow(false);
      else setShow(true);
    }
  }, [event, timecard]);

  if (!show) return '';
  if (!event) return '';

  return (
    <EventCard
      event={event}
      timecardId={timecard.timecardId}
      title="** Meeting Detected **"
    />
  );
};

export default DetectMeeting;
